export default class Locale_FindAvailableCapacityDialog {
	ResourceMustBeSpecified: string = "Resource must be specified!";
	WorkMustBeSpecified: string = "Work must be specified!";
	StartMustBeSpecified: string = "Start must be specified!";
	EndMustBeSpecified: string = "End must be specified!";
	ContractNameMustBeSpecified: string = "Contract name must be specified!";
	FindPossibleDeliveryDate: string = "Find possible delivery date";
	DistrinuteRequestEvenly: string = "Distribute request evenly from start to end";
	ScenarioNotFilledOut: string = "Scenario not selected!";
}